import React, { useCallback, useState, useContext } from 'react'
import PropTypes from 'prop-types'
import withApolloProvider from 'components/hocs/withApolloProvider'
import withReduxProvider from 'components/hocs/withReduxProvider'
import { useQuery } from '@apollo/client'
import { compose } from 'redux'
import { fireGtmEvent } from 'utils/gtm'
import WidgetContext from 'components/widget-context'
import { event } from '@cred/shared/ga'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import querystring from 'querystring'
import uuidGenerator from 'uuid/v4'
import Footer from 'components/footer'
import CtaButton from 'components/cta-button'
import { AdvertiserDisclosure } from 'components/advertiser-disclosure'
import config from 'config'
import WidgetPage from 'components/hocs/widget-page'
import CardTile from './card-tile'
import styles from './styles.scss'
import { GET_CARDS_QUERY } from './api/queries'
import CardsFilter from './filter'
import Spinner from './spinner'
import NoCards from './no-cards'

const form = 'credit-cards-category',
  defaultCategory = 'featured',
  footerDisclosure = 'partners-widgets.advertiser-disclaimer.cc',

  CreditCardsTable = ({ category, theme, utms }) => {
    const showDisclosure = ['fox', 'thebalance1', 'investopedia1'].includes(theme),
      [details, setDetails] = useState({}),
      handleToggleDetails = useCallback((slug) => {
        setDetails({ [slug]: !details[slug] })
      }, [details]),
      { loading, error, data } = useQuery(GET_CARDS_QUERY, {
        variables: {
          limit: 3,
          category,
        },
      }),
      widgetContext = useContext(WidgetContext),
      onClickCta = useCallback(() => {
        fireGtmEvent('ctaClick',
          { category, ...widgetContext })
        event({ category, action: 'Go to Credible Website CTA Click', label: category })
      }, [category, widgetContext]),
      appendUtmQueryParameters = url => `${url}?${querystring.encode(utms)}`

    return (
      <>
        {showDisclosure && <AdvertiserDisclosure tooltipId="fox-disclosure" theme={theme} />}
        <div className={`${styles.ccWidget} mt-8`}> <CardsFilter form={form} />
          {loading ? (
            <Spinner />
          ) : (
            <>
              {data.creditCards.length ? (
                <div className="mt-8">
                  {data.creditCards.map(({ slug, name, ...props }) => {
                    const applyNowUrl = appendUtmQueryParameters(`/credit-cards/apply-now/link-card/${slug}`)
                    const uuid = uuidGenerator()
                    return (
                      <CardTile
                        {...props}
                        key={slug}
                        slug={slug}
                        name={name}
                        category={category}
                        isDetailsOpen={!!details[slug]}
                        onToggleDetails={handleToggleDetails}
                        ctaUrl={`${applyNowUrl}&redirection_uuid=${uuid}`}
                        uuid={uuid}
                      />
                    )
                  })}
                </div>
              ) : (
                <NoCards />
              )}
            </>
          )}
          {error && <NoCards />}
          <CtaButton
            fullWidth
            blank
            className="mt-8"
            href={appendUtmQueryParameters(`${config.credibleRoot}/credit-cards/all-credit-cards`)}
            onClick={onClickCta}
          >
            Compare more Cards
          </CtaButton>
          <Footer footerDisclosure={footerDisclosure} />
        </div>
      </>
    )
  }

CreditCardsTable.propTypes = {
  theme: PropTypes.string.isRequired,
  utms: PropTypes.object.isRequired,
  category: PropTypes.string,
}

CreditCardsTable.defaultProps = {
  category: defaultCategory,
}

const selector = formValueSelector(form),
  mapStateToProps = (state) => ({
    category: selector(state, 'categoryFilter'),
    initialValues: {
      categoryFilter: defaultCategory,
    },
  })

export { CreditCardsTable, footerDisclosure }
export default compose(
  WidgetPage,
  withApolloProvider,
  withReduxProvider,
  connect(mapStateToProps),
  reduxForm({ form }),
)(CreditCardsTable)
